"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
exports.default = (function (_a) {
    var body = _a.body, header = _a.header, link = _a.link, linkClassNames = _a.linkClassNames, onClick = _a.onClick;
    var headerContent = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('cell text-left font-size-14 margin-bottom-4', { 'small-8': onClick, 'small-12': !onClick }), onClick: onClick }, header),
        onClick && (react_1.default.createElement("div", { className: 'cell small-4 text-right', onClick: onClick },
            react_1.default.createElement("i", { id: "edit-".concat(header), className: 'ss-right clickable' })))));
    // if no link is provided, return a div block of the same style instead
    return link ? (react_1.default.createElement("div", { className: (0, classnames_1.default)(linkClassNames, 'padding-vertical-5 padding-horizontal-3 bg-white grid-x grid-padding-x') },
        react_1.default.createElement(react_router_dom_1.Link, { to: link, onClick: onClick }, headerContent),
        body)) : (react_1.default.createElement("div", { className: (0, classnames_1.default)(linkClassNames, 'padding-vertical-5 padding-horizontal-3 bg-white grid-x grid-padding-x') },
        headerContent,
        body));
});
